import { defineNuxtPlugin } from '#app';

// Credit:
// - [Repo](https://github.com/Isa3v/nuxt-spa-loading-template/blob/main/module.ts)
// - [Issue](https://github.com/nuxt/nuxt/issues/21721)

const REMOVE_AFTER = 2000;

// This Nuxt plugin performs the following actions:
// 1. Creates and mounts a component in the DOM to display a loading state.
// 2. Removes the loading component after the page loading is completed.

export default defineNuxtPlugin((nuxtApp) => {
  // This is necessary for server-side calls.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!window || !window.location.pathname.startsWith('/admin')) {
    return;
  }

  // This is necessary for server-side calls.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (document?.body) {
    // Create a 'div' element to display the loading component.
    const loaderHtmlComponent = document.createElement('div');
    // Insert the HTML code for the loading component, specified in the plugin options.
    loaderHtmlComponent.innerHTML = html;
    // Insert the loading component at the beginning of the document's body.
    document.body.insertBefore(loaderHtmlComponent, document.body.firstChild);

    const removeHTMLComponent = () => {
      // Remove the loading component.
      loaderHtmlComponent.remove();
    };

    // Register the 'page:finish' hook to perform actions after page loading is complete.
    nuxtApp.hook('page:finish', () => {
      setTimeout(() => {
        // Remove the loading component.
        removeHTMLComponent();
      }, REMOVE_AFTER);
    });

    // Remove element after fatal error occures
    nuxtApp.hook('app:error', () => {
      // Remove the loading component.
      removeHTMLComponent();
    });
  }
});

const html = `
<div class="absolute z-10000 flex h-screen w-screen items-center justify-center bg-cms-gray-600">
  <div class="spinner aspect-square"></div>
</div>

<style>
  :root {
    --spinner-width: 56px;
    --spinner-mask-stop: 9px;
  }

  .spinner {
    width: var(--spinner-width);
    border-radius: 50%;
    background:
      radial-gradient(farthest-side, #453c7e 94%, #0000) top/var(--spinner-mask-stop) var(--spinner-mask-stop) no-repeat,
      conic-gradient(#0000 30%, #453c7e);
    -webkit-mask: radial-gradient(farthest-side,
        #0000 calc(100% - var(--spinner-mask-stop)),
        #000 0);
    animation: spinner-c7wet2 1s infinite linear;
  }

  @keyframes spinner-c7wet2 {
    100% {
      transform: rotate(1turn);
    }
  }
</style>
`;
